/** @jsx jsx */
import React from 'react';

import { jsx } from '@emotion/react';
import styled from '@emotion/styled';

import { Fields } from '../../components/Fields';
import { FullPageLoader } from '../../components/Loader';
import { useFormFields } from '../../hooks';
import {
    Event,
    useFormEvents,
} from './useFormEvents';

interface ContainerProps {
    fields: any;
    event: Event;
}

export const Form: React.FC<ContainerProps> = ({ fields, event, ...props }) => {
    const [fieldValues, setFieldValues] = useFormFields(fields);
    const [fieldErrors, setFieldErrors] = useFormFields(fields);

    const { onSubmit, showLoader } = useFormEvents(event, fieldValues);

    if (showLoader) {
        return <FullPageLoader />;
    }

    return (
        <StyledForm {...props} onSubmit={onSubmit}>
            <Fields
                fields={fields}
                fieldValues={fieldValues}
                setFieldValues={setFieldValues}
                fieldErrors={fieldErrors}
                setFieldErrors={setFieldErrors}
                inputType="formField"
            />
        </StyledForm>
    );
};

const StyledForm = styled.form`
    width: 100%;

    margin: 0 auto;
`;
